import { ProgressBar, ProgressWrapper } from './Modal.styles.js';

type ModalProgressProps = {
  readonly percent: number;
};

const ModalProgress = ({ percent }: ModalProgressProps) => {
  return (
    <ProgressWrapper>
      <ProgressBar percent={percent} />
    </ProgressWrapper>
  );
};

ModalProgress.displayName = 'Modal.Progress';

export { ModalProgress };
